import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Child } from 'src/app/shared/interfaces/child.interface';

@Injectable({
  providedIn: 'root',
})
export class ChildService {
  constructor(private http: HttpClient) {}

  get(): Promise<any> {
    return this.http.get('@cec-api/child').toPromise();
  }

  getByGroup(groupId: number): Promise<any> {
    return this.http.get(`@cec-api/groups/${groupId}/users`).toPromise();
  }

  getById(id: number): Promise<any> {
    return this.http.get('@cec-api/child/' + id).toPromise();
  }

  addChild(user: Child): Promise<any> {
    return this.http.post('@cec-api/child', user).toPromise();
  }

  updateChild(user: Child, id: number): Promise<any> {
    return this.http.put('@cec-api/child/' + id, user).toPromise();
  }

  deleteChild(id: number): Promise<any> {
    return this.http.delete('@cec-api/child/' + id).toPromise();
  }

  searchChild(text: string): Promise<any> {
    return this.http.get(`@cec-api/child?name=${text}`).toPromise();
  }
}
